import { render, staticRenderFns } from "./purchaseDetail.vue?vue&type=template&id=3ec0105e&scoped=true&"
import script from "./purchaseDetail.vue?vue&type=script&lang=js&"
export * from "./purchaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./purchaseDetail.vue?vue&type=style&index=0&id=3ec0105e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec0105e",
  null
  
)

export default component.exports